import React from "react";
import "./tab-content-title.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

interface TabContentTitleComponentProps {
  title: string;
  subTitle: string;
  loading: boolean;
}
const TabContentTitleComponent = ({
  title,
  subTitle,
  loading,
}: TabContentTitleComponentProps) => {
  return (
    <Box className="title mb-4">
      {loading ? (
        <Skeleton variant="text" height={20} width={350} />
      ) : (
        <Typography
          variant="h2"
          color="textPrimary"
          className="text-capitalize"
        >
          {title}
        </Typography>
      )}
      {loading ? (
        <Skeleton variant="text" height={18} width={250} />
      ) : (
        <Typography variant="body1" color="textSecondary">
          {subTitle}
        </Typography>
      )}
    </Box>
  );
};

export default TabContentTitleComponent;
